import React from "react";
import "./Brown_btn.css";
import { Button } from "react-bootstrap";

function Brown_btn({ btnText, onClick, type = "button", disabled = false }) {
  return (
    <>
      <section className="Brown_btn_holder">
        <Button
          className="Brown_btn"
          onClick={onClick}
          type={type}
          disabled={disabled}
        >
          {btnText}
        </Button>
      </section>
    </>
  );
}

export default Brown_btn;
